
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "./BaseButton";
import UIButton from "../../components/core/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnNextLevel extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 60.5, y ?? 60.5);

    // btn
    const btn = scene.add.image(0, 0, "endscreen", "popup-btn-right.png");
    this.add(btn);

    // icon_home_png
    const icon_home_png = scene.add.image(2, -5, "endscreen", "popup-icon-next.png");
    this.add(icon_home_png);

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.shouldPulse = true;
    thisUIButton.pulseDelay = 6000;
    thisUIButton.pulseScaleEnd = 1.1;
    thisUIButton.pulseSpeed = 500;
    thisUIButton.pulseEase = Phaser.Math.Easing.Quadratic.InOut;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
